import { render, staticRenderFns } from "./myFavorite.vue?vue&type=template&id=35b7d28c&scoped=true&"
import script from "./myFavorite.vue?vue&type=script&lang=js&"
export * from "./myFavorite.vue?vue&type=script&lang=js&"
import style0 from "./myFavorite.vue?vue&type=style&index=0&id=35b7d28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7d28c",
  null
  
)

export default component.exports